import each from "lodash/fp/each";
import map from "lodash/fp/map";
import isObject from "lodash/fp/isObject";
import first from "lodash/fp/first";
import isNil from "lodash/fp/isNil";
import searchTmpl from "./searchTemplate.html";
import filterTmpl from "./filterTemplate.html";

import exactDialogCtrl from "../dialogs/exactDialog/exactDialog.controller";
import exactDialog from "../dialogs/exactDialog/exactDialog.html";
class Controller {
  constructor(Lists, Events, $state, $mdDialog, $injector, FillParams) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Lists = Lists.all;
    this.Events = Events;
    this.$state = $state;
    this.$injector = $injector;
    this.FillParams = FillParams;

    this.filterEventName = Events.getFilterEvent("filter");
  }

  $onInit() {
    this.Events.on(this.filterEventName, this.emitEvent.bind(this));

    const mapName = (item) => {
      if (item._type === "bus") return item._source.plates;
    };
    const addName = (item) => {
      if (!item._source) {
        item._source = {
          name: item.name,
        };
      } else if (!item._source.name) {
        item._source.name = mapName(item);
      }
      return item;
    };
    if (this.dynamicFiltersEvents) {
      const allDynamicFiltersEventsEmitted = this.Events.eventsHaveListeners(
        this.dynamicFiltersEvents
      ).every(Boolean);

      if (allDynamicFiltersEventsEmitted) {
        this.filters = this.FillParams.get(
          this.activeParams,
          this.activeFilters
        );
      } else {
        this.Events.onAll(this.dynamicFiltersEvents, () => {
          this.filters = this.FillParams.get(
            this.activeParams,
            this.activeFilters
          );
        });
      }
    } else {
      this.filters = this.FillParams.get(this.activeParams, this.activeFilters);
    }

    const filtersPromiseArray = this.activeFilters.map((activeFilter) => {
      if (
        activeFilter.isList &&
        activeFilter.resource &&
        activeFilter.resourceMethod
      ) {
        const request = this.$injector
          .get(activeFilter.resource)
          [activeFilter.resourceMethod](activeFilter.resourceParams);
        return request.$promise.then((response) => {
          if (response.hits) {
            activeFilter.onResourceSuccess(response.hits);
          }
        });
      }
      return Promise.resolve("Skip");
    });

    Promise.all(filtersPromiseArray)
      .then(() => {
        this.filters = this.FillParams.get(
          this.activeParams,
          this.activeFilters
        );
      })
      .catch(function (err) {
        console.error("Error getting some filters lists", err);
      });

    this.onAutoCompleteSearch = (
      text,
      resourceName,
      resourceMethod,
      resourceParams
    ) => {
      const resource = this.$injector.get(resourceName);
      const request = resource[resourceMethod || "search"](
        text,
        resourceParams
      );
      return request.$promise.then((list) => map(addName)(list.hits));
    };

    this.onClear = (name, index, keyToBeCleared) => {
      const options = {};
      options[name] = null;

      if (keyToBeCleared) {
        this.filters[index][keyToBeCleared] = null;
        this.emitEvent({ [name]: null });
      } else this.filters[index].searchText = null;
    };

    this.onAutoCompleteSelect = (selected, name) => {
      const options = {};
      if (selected.name) {
        if (selected.name && isObject(selected.name)) {
          options[name] = selected.name._id;
        } else if (selected._id) {
          options[name] = selected._id;
        }
      } else {
        options[name] = null;
      }
      this.emitEvent(options);
    };

    this.onSearchChange = (search) => {
      if (search) {
        this.emitEvent(search);
      }
    };

    this.onListSelect = (selected) => {
      if (selected) {
        const options = {};
        options[selected.param] = selected.name;

        this.emitEvent(options);
      }
    };

    this.onListMultipleSelect = (selected, list) => {
      const options = {};
      const setOption = (option) => {
        if (isNil(options[option.param])) {
          options[option.param] = [option._id || option.name];
        } else {
          options[option.param].push(option._id || option.name);
        }
      };

      each(setOption)(selected);
      if (Object.keys(options).length === 0) {
        options[first(list).param] = null;
      }
      this.emitEvent(options);
    };

    this.onSearchSelect = (selected, state) => {
      if (selected && selected.name && selected.name._id) {
        this.$state.transitionTo(state, {
          id: selected.name._id,
        });
      }
    };

    this.searchCustomTemplate = searchTmpl;
    this.filterCustomTemplate = filterTmpl;
  }

  openExact(option) {
    const add = this.$mdDialog.show({
      controller: exactDialogCtrl,
      controllerAs: "$ctrl",
      template: exactDialog,
      multiple: true,
      locals: {
        option,
      },
    });
    const hasExactSearch = option && option.isSearch && option.hasExact;

    add.then((obj) => {
      if (hasExactSearch) {
        this.$state.transitionTo(option.state, {
          id: obj._id,
        });
      }
      option.selectedItem = obj;
    }, angular.noop);
  }

  emitEvent(options) {
    this.activeParams = { ...this.activeParams, ...options, page: 1 };

    this.Events.emit(this.eventName, this.activeParams);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/listFilter/listFilter.controller.js